import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-sand bg-paper">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <p className="text-[11px] leading-relaxed text-clay/90 max-w-5xl">
          SMS+ — Profitez du service en envoyant ACCESS au 82031. Le service
          IQ Brain Gamers comprend un entraînement cognitif, avec des séances de
          pleine conscience et un soutien communautaire pour une approche
          holistique du bien-être mental. Vous disposerez de 50 jeux en ligne, de
          façon illimitée pendant 3 mois. Le coût de l&apos;accès au service est
          de 4,5&nbsp;€ bruts (TVA incluse). Pour le support, joignez le
          0171255555 ou{' '}
          <a
            href="mailto:customer-support@allopass.com"
            className="underline underline-offset-2 hover:text-pine-600"
          >
            customer-support@allopass.com
          </a>
          .
        </p>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
          <div>
            <a href="/" className="font-display text-lg font-semibold">
              IQ Brain Gamers
            </a>
            <p className="mt-1 text-xs text-clay">
              Clickzillas B.V. · Nassaukade 157H, 1053 LK Amsterdam, Pays-Bas
            </p>
          </div>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
            <a
              href="/conditions-generales-de-vente.html"
              className="text-clay hover:text-pine-600 transition-colors"
            >
              Conditions générales de vente
            </a>
            <a
              href="mailto:customer-support@allopass.com"
              className="text-clay hover:text-pine-600 transition-colors"
            >
              Contact
            </a>
          </nav>
        </div>

        <p className="mt-8 text-xs text-clay">©2026 Clickzillas B.V.</p>
      </div>
    </footer>
  );
}
